import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import {MemberBackgroundData} from 'src/app/models/member-background-data';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-background-dialog',
  templateUrl: './member-background-dialog.component.html',
  styleUrls: [ './member-background-dialog.component.scss' ]
})
export class MemberBackgroundDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  public form: FormGroup;
  public isEdit: boolean

  public backgroundLocations: any[] = [];

  constructor (
    private fb: FormBuilder,
    public matDialogRef: MatDialogRef<MemberBackgroundDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MemberBackgroundData
  ) {

    if (this.data.id == '0') {
      this.isEdit = false
    } else {
      this.isEdit = true
    }
    this.form = this.createForm(this.data)
  }

  ngOnInit () {
    this.backgroundLocations.push({name: "Não se aplica", value: "none"})
    this.backgroundLocations.push({name: "MEC - Ministério Educação e Cultura", value: "MEC"})
    this.backgroundLocations.push({name: "SBCCV - Centro Reconhecido pela SBCCV", value: "SBCCV"})
  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      text: new FormControl(data.text, [ Validators.required ]),
      dateStart: new FormControl(data.dateStart, [ Validators.required ]),
      dateEnd: new FormControl(data.dateEnd, [ Validators.required ]),
      location: new FormControl(data.location, [ Validators.required ]),
      member_id: new FormControl(data.member_id),
      member_name: new FormControl(data.member_name)
    });
    return form
  }



}
